import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

import { ActivityMetadataModel } from '../../../../api/api';
import { ActivityModel } from '../../Models/FlowModel';
import ActivityIcon from '../ActivityIcon';
import DisplayContentTemplate from '../DisplayContentTemplate';

type CompactAgentServiceIconProps = {
	activity: ActivityModel;
	activityMetadata: ActivityMetadataModel | undefined;
};

export default function CompactAgentServiceIcon({ activity, activityMetadata }: CompactAgentServiceIconProps) {
	return (
		<Tooltip title={
			<DisplayContentTemplate
				template={activityMetadata?.displayContent}
				fallbackText={activityMetadata?.displayName ?? activity.Type}
				context={activity}
			/>
		}>
			<Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', '& svg': { transform: 'none !important' } }}>
				<ActivityIcon activityMetadata={activityMetadata} maxWidth="24px" />
			</Box>
		</Tooltip>
	);
}
